import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/settings/admin/storybook",
      },
      queries: [],
    }),
    [],
  );
}

export const useStorybookSettingsPageNavigator = createPageNavigator<void>({
  useNavigator,
});
